/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

import { useContext } from 'react';
import { NarrativeContext } from '@/context';
import { NarrativeContextValue } from 'types/narrative-graph';

export const useNarrative = (): NarrativeContextValue => {
  const context = useContext(NarrativeContext);
  if (!context) {
    throw new Error('useNarrative must be used within a NarrativeProvider');
  }
  return context;
};
